/**
 * Used to combine multiple reducers (React.useReducer)
 * @param combinedReducers An Record of <string, Reducer>
 * @returns An array with [state, dispatch] combined
 * @author This is a copy of https://github.com/the-road-to-learn-react/use-combined-reducers because of transpiled version is using window (not needed), and it cause issues with Next server
 */
const useCombinedReducers = <T, A>(
  combinedReducers: Record<keyof T, [T[keyof T], React.Dispatch<A>]>,
): [T, (action: A) => void] => {
  // Global State
  const state = Object.keys(combinedReducers).reduce(
    (acc, key) => ({ ...acc, [key]: combinedReducers[key][0] }),
    {},
  ) as T

  // Global Dispatch Function
  const dispatch = (action: A) =>
    Object.keys(combinedReducers)
      .map((key) => combinedReducers[key][1])
      .forEach((fn) => fn(action))

  return [state, dispatch]
}
export default useCombinedReducers
